<template>
    <div class="col-sm-auto my-auto">
      <template v-if="crew.active == 1 || isSystemAdmin">
        <button class="btn btn-sm btn-xs btn-outline-primary"
                data-toggle="modal"
                data-target="#upload-crew-health-declaration"
        >
          <span class="fas fa-upload" v-if="!isKline"></span>
          Upload Health Checklist
        </button>
      </template>

        <CmsModal unique="upload-crew-health-declaration" title="Upload Crew Health Declaration">

            <form @submit.prevent="confirmUploadCrewMedicalDeclaration">
                <div class="form-group form-row mb-1" :class="{'has-error': newHealthDeclarationError.submitted_at}">
                    <label class="col col-sm-3 col-form-label font-weight-bolder text-left" for="submitted-at" >
                        Submitted At:
                    </label>

                    <div class="col col-sm-9">
                        <input type="date" id="submitted-at" required
                               class="form-control form-control-xs"
                               v-model="newHealthDeclaration.submitted_at"
                        >
                        <span class="help-block" v-if="newHealthDeclarationError.submitted_at !== ''">
                            <small><strong>{{ newHealthDeclarationError.submitted_at }}</strong></small>
                        </span>
                    </div>
                </div>

                <div class="form-group form-row mb-1" :class="{'has-error': newHealthDeclarationError.has_symptoms}">
                    <label class="col col-sm-3 col-form-label font-weight-bolder text-left" for="has-symptoms" >
                        Has Symptoms:
                    </label>

                    <div class="col col-sm-9 text-left">
                        <div class="row">
                            <div class="col col-sm-2">
                                <input type="checkbox" id="has-symptoms"
                                       class="form-control form-control-xs"
                                       v-model="newHealthDeclaration.has_symptoms"
                                >
                            </div>
                            <div class="col col-sm-10">
                                <input type="text" readonly
                                       :value="newHealthDeclaration.has_symptoms ? 'YES' : 'NO'"
                                       class="form-control form-control-xs border-0 font-weight-bold bg-white"
                                       :class="{'text-danger' : newHealthDeclaration.has_symptoms}"
                                >
                            </div>
                        </div>
                        <span class="help-block" v-if="newHealthDeclarationError.has_symptoms !== ''">
                            <small><strong>{{ newHealthDeclarationError.has_symptoms }}</strong></small>
                        </span>
                    </div>
                </div>

                <div class="form-group form-row mb-1" id="file-container">
                    <label class="col col-sm-3 col-form-label font-weight-bolder text-left" for="file" >
                        File:
                    </label>

                    <div class="col col-sm-9" :class="{'has-error': newHealthDeclarationError.file}">
                        <input type="file" id="file" required
                               class="form-control form-control-xs"
                        >
                        <span class="help-block" v-if="newHealthDeclarationError.file !== ''">
                            <small><strong>{{ newHealthDeclarationError.file }}</strong></small>
                        </span>
                    </div>
                </div>

                <button type="submit" class="btn btn-primary btn-sm float-right">
                    <i class="fas fa-save"></i>
                    Save changes
                </button>
            </form>

        </CmsModal>
    </div>
</template>

<script>
import CmsModal from "@/components/elements/CmsModal";
import { mapActions, mapGetters } from 'vuex';
import { vueAppMixin } from "@/mixins/vueAppMixin";
import { formMixin } from "@/mixins/formMixin";
import {gateMixin} from "@/mixins/gateMixin";

export default {
    name: "UploadHealthChecklist",
    mixins: [ vueAppMixin, formMixin, gateMixin ],
    components: { CmsModal },
    data() {
        return {
            newHealthDeclaration: {},
            newHealthDeclarationError: {},
        }
    },

    methods: {
        ...mapActions([ 'uploadCrewMedicalDeclaration' ]),

        async confirmUploadCrewMedicalDeclaration() {
            if(await this.confirmCreateAlert()) {
                let formData = new FormData();
                formData.append('crew_id', this.crew.id);
                formData.append('submitted_at', this.newHealthDeclaration.submitted_at);
                if(this.newHealthDeclaration.has_symptoms) {
                    formData.append('has_symptoms', this.newHealthDeclaration.has_symptoms);
                }
                let medicalFile = document.getElementById('file');
                if (medicalFile.files && medicalFile.files[0]) {
                    let file = medicalFile.files[0];
                    formData.append('medicalFile', file);
                }
                let uploadedMedicalDeclaration = this.uploadCrewMedicalDeclaration(formData);
                if(uploadedMedicalDeclaration) {
                    if(uploadedMedicalDeclaration.errors) {
                        this.newHealthDeclarationError = uploadedMedicalDeclaration.errors;
                    } else {
                        this.successAlert('Crew Medical Declaration Successfully Uploaded', 'UPLOAD');
                        this.refreshInputFile('file-container');
                        this.newHealthDeclaration = {};
                        this.newHealthDeclarationError = {};
                        document.getElementById('close-upload-crew-health-declaration').click();
                    }
                }
            }
        }

    },

    computed: {
        ...mapGetters([ 'crew'])
    }
}
</script>

<style scoped>

</style>